import React from "react";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  FloatingButton,
  Text,
  SwipeTabs,
  SwipeTab,
} from "../../../styles/Global";
import * as Global from "../../../styles/Global";
import moment from "moment";
import GridCustomEvents from "../../../components/GridCustomEvents";
import { AiFillCaretLeft } from "react-icons/ai";
import { ordinal_suffix_of } from "../../../functions/helperFunctions";
import { BiHandicap } from "react-icons/bi";
import DuprLightIcon from "../../../assets/icons/DuprLightIcon";
import BicepIcon from "../../../assets/icons/BicepIcon";
import HelipadIcon from "../../../assets/icons/HelipadIcon";
import GodPowerCTA from "../../organizer/modals/components/godPower/GodPowerCTA";

const sport = new URL(window.location.href).pathname.split("/")[2];

const setFilterParams = {
  selectAllOnFilter: false,
  defaultToNothingSelected: true,
  suppressSelectAll: true,
  buttons: [],
  closeOnApply: false,
  excelMode: "windows",
};

// Base column configuration with sorting and filtering enabled
const baseColumnDef = {
  sortable: true,
  filter: true,
  resizable: true,
  suppressMovable: false, // Ensure this is set to false to allow column reordering
  // Add vertical centering for all cells
  cellStyle: {
    display: "flex",
    alignItems: "center",
  },
};

// For specific columns that have the Loading... problem
const sportFilterParams = {
  ...setFilterParams,
  cellRenderer: (params) => params.value,
  suppressMiniFilter: false,
  suppressFilterSearch: false,
};

export const gridGodpowerColDefs = [
  {
    ...baseColumnDef,
    headerName: "",
    minWidth: 90,
    maxWidth: 90,
    pinned: "left",
    floatingFilter: false,
    filter: false,
    sortable: false,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
    cellRenderer: (params) => {
      return <GodPowerCTA data={params.data} />;
    },
  },
  {
    ...baseColumnDef,
    headerName: "Date/Time",
    field: "gametime",
    hide: false,
    minWidth: 150,
    maxWidth: 150,
    width: 150,
    floatingFilter: false,
    suppressMenu: false,
    filter: "agDateColumnFilter",
    filterParams: {
      comparator: function (filterLocalDateAtMidnight, cellValue) {
        if (!cellValue) return -1;
        const cellDate = new Date(cellValue * 1000);
        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
          return 0;
        }
        return filterLocalDateAtMidnight.getTime() > cellDate.getTime()
          ? 1
          : -1;
      },
    },
    cellRenderer: (params) => {
      if (params.value) {
        return (
          <FlexColumn>
            <Text size=".9em">
              {moment(params.value, "X").format("ddd MMM DD, YYYY")}
            </Text>
            <Text size=".9em">{moment(params.value, "X").format("h:mma")}</Text>
          </FlexColumn>
        );
      } else {
        return "";
      }
    },
  },
  {
    ...baseColumnDef,
    headerName: "Title",
    field: "name",
    minWidth: 250,
    maxWidth: 300,
    wrapText: true,
    filter: "agTextColumnFilter",
  },
  {
    ...baseColumnDef,
    headerName: "Sport",
    field: "sport",
    minWidth: 120,
    maxWidth: 120,
    filter: "agSetColumnFilter",
  },
  {
    ...baseColumnDef,
    headerName: "Format",
    field: "format",
    minWidth: 140,
    maxWidth: 140,
    filter: "agSetColumnFilter",
  },
  {
    ...baseColumnDef,
    headerName: "Team",
    field: "teamcreate",
    minWidth: 100,
    maxWidth: 100,
    filter: "agSetColumnFilter",
  },
  {
    ...baseColumnDef,
    headerName: "Club",
    field: "orgname",
    minWidth: 150,
    maxWidth: 200,
    wrapText: true,
  },
  {
    ...baseColumnDef,
    headerName: "Location",
    field: "locationfullname",
    minWidth: 250,
    maxWidth: 300,
    wrapText: true,
  },
  {
    ...baseColumnDef,
    headerName: "Status",
    field: "status",
    minWidth: 100,
    maxWidth: 100,
  },
  {
    ...baseColumnDef,
    headerName: "Progress",
    field: "progress.percent",
    minWidth: 140,
    maxWidth: 120,
    valueFormatter: (params) => {
      if (params.value) {
        return (
          params.value +
          "%" +
          " (" +
          params.data.progress.completed +
          " of " +
          params.data.progress.total +
          ")"
        );
      } else {
        return "-";
      }
    },
  },
  {
    ...baseColumnDef,
    headerName: "Courts",
    field: "boards",
    minWidth: 100,
    maxWidth: 100,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Scoring",
    field: "scoring",
    minWidth: 140,
    maxWidth: 140,
    wrapText: true,
  },
  {
    ...baseColumnDef,
    headerName: "Rounds",
    field: "rounds",
    minWidth: 100,
    maxWidth: 100,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Max Teams",
    field: "gamemaxteams",
    minWidth: 150,
    maxWidth: 150,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Registered",
    field: "gameregistered",
    minWidth: 150,
    maxWidth: 150,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Visibility",
    field: "gamevisibility",
    minWidth: 150,
    maxWidth: 150,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Player Scoring",
    field: "playerScoring",
    minWidth: 150,
    maxWidth: 150,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Restrictions",
    field: "restrictionsCount",
    minWidth: 150,
    maxWidth: 150,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Season",
    field: "seasonId",
    minWidth: 180,
    maxWidth: 180,
  },
  {
    ...baseColumnDef,
    headerName: "timezone",
    field: "timezone",
    minWidth: 160,
    maxWidth: 160,
    wrapText: true,
  },
  {
    ...baseColumnDef,
    headerName: "Waitlist",
    field: "waitlist",
    minWidth: 100,
    maxWidth: 100,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Waitlist Count",
    field: "waitlistCount",
    minWidth: 150,
    maxWidth: 150,
    cellStyle: {
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
  },
  {
    ...baseColumnDef,
    headerName: "Back-to-Back Courts",
    field: "useLastCourt",
    minWidth: 180,
    maxWidth: 180,
  },
  {
    ...baseColumnDef,
    headerName: "Block Same Court",
    field: "useAllCourts",
    minWidth: 180,
    maxWidth: 180,
  },
  {
    ...baseColumnDef,
    headerName: "Score Method",
    field: "scoreMethod",
    minWidth: 140,
    maxWidth: 140,
  },
];
